import { Card } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { FormTab, TabbedForm, useDataProvider, useNotify, useRefresh } from "react-admin";
import { sortByAmountTickets } from "../../helpers/creditsArray";
import { getGeneral } from "../../helpers/getGeneral";
import { UpdateDiscountsGeneralRequest } from "../../types/credits";
import { DiscountProps, GeneralDiscount, isActiveGeneralDiscount } from "../../types/generalSettings";
import { DiscountPickerComponent } from "../common/generalPickersBlocks/discounts/DiscountPickerComponent";
import "./style.css";

const setDiscount = (generalDiscount: GeneralDiscount): GeneralDiscount => {
  let discounts = generalDiscount
  discounts.raffle = discounts.raffle ? discounts.raffle.map((i) => {
    return {
      ...i,
      id: "_" + Math.random().toString(36).substr(2, 9),
    }
  }) : []
  discounts.prize = discounts.prize ? discounts.prize.map((i) => {
    return {
      ...i,
      id: "_" + Math.random().toString(36).substr(2, 9),
    }
  }) : []
  discounts.fixedOdds = discounts.fixedOdds ? discounts.fixedOdds.map((i) => {
    return {
      ...i,
      id: "_" + Math.random().toString(36).substr(2, 9),
    }
  }) : []
  return discounts
}

const removeId = (generalDiscount: GeneralDiscount): GeneralDiscount => {
  generalDiscount.raffle = generalDiscount.raffle ?
    generalDiscount.raffle.map((i) => {
      const { id, ...rate } = i
      return {
        ...rate
      }
    }) : [];
  generalDiscount.prize = generalDiscount.prize ?
    generalDiscount.prize.map((i) => {
      const { id, ...rate } = i
      return {
        ...rate
      }
    }) : [];
  generalDiscount.fixedOdds = generalDiscount.fixedOdds ?
    generalDiscount.fixedOdds.map((i) => {
      const { id, ...rate } = i
      return {
        ...rate
      }
    }) : [];
  return generalDiscount
}

export const DiscountsLayout = () => {
  const notify = useNotify();
  const refresh = useRefresh();
  const dataProvider = useDataProvider();
  const [isActiveDicounts, setDoesDiscountsActive] = useState<isActiveGeneralDiscount>({ raffle: false, fixedOdds: false, prize: false });
  const [stateDiscounts, setDiscounts] = useState<GeneralDiscount>({ raffle: [], fixedOdds: [], prize: [] });
  const [discountFillError, setDiscountFillError] = useState<isActiveGeneralDiscount>({ raffle: false, fixedOdds: false, prize: false })
  const docId = useRef<number | null>(null);

  useEffect(() => {
    setCreditsToState();
  }, []);

  const setCreditsToState = async () => {
    const general = await getGeneral();
    let discountRates = setDiscount(general.discountRates)
    discountRates.raffle = sortByAmountTickets(discountRates.raffle)
    discountRates.prize = sortByAmountTickets(discountRates.prize)
    discountRates.fixedOdds = sortByAmountTickets(discountRates.fixedOdds)
    setDiscounts(discountRates);
    if (Object.keys(general.isDiscountRates).length > 0) {
      setDoesDiscountsActive(general.isDiscountRates);
    }
    docId.current = general._id;
  };

  const handleChangeDiscountsStatus = (competition: string) => {
    setDoesDiscountsActive({ ...isActiveDicounts, [competition]: !isActiveDicounts[competition] });
  };

  const handleSetDiscount = (discountsArr: Array<DiscountProps>, competition: string) => {
    setDiscounts({ ...stateDiscounts, [competition]: discountsArr });
  };

  const handleSaveDiscounts = async () => {
    const creditsRatesWithoutId = removeId(stateDiscounts)

    const discountRates: GeneralDiscount = {
      raffle: isActiveDicounts.raffle ? creditsRatesWithoutId.raffle : [],
      prize: isActiveDicounts.prize ? creditsRatesWithoutId.prize : [],
      fixedOdds: isActiveDicounts.fixedOdds ? creditsRatesWithoutId.fixedOdds : []
    }

    const discountError: isActiveGeneralDiscount = {
      raffle: isActiveDicounts.raffle && creditsRatesWithoutId.raffle.length === 0 ? true : false,
      prize: isActiveDicounts.prize && creditsRatesWithoutId.prize.length === 0 ? true : false,
      fixedOdds: isActiveDicounts.fixedOdds && creditsRatesWithoutId.fixedOdds.length === 0 ? true : false
    }



    if (discountError.raffle || discountError.prize || discountError.fixedOdds) {
      setDiscountFillError(discountError)
      return
    }

    const dataForRequest: UpdateDiscountsGeneralRequest = {
      discountRates: discountRates,
      isDiscountRates: isActiveDicounts,
    };

    const result = await dataProvider.updateGeneral({
      id: docId.current,
      data: dataForRequest,
      previousData: {} as any,
    });

    if (!result.data) {
      notify("something went wrong", "error");
    }
    notify(`Discounts successfully update`);
    refresh();
  };
  return (
    <Card component="div" className="tabCardWrapper creditsTabLayout user-toolbar" id="general-tabs-form">
      <TabbedForm className="user-tabs" toolbar={<></>}>
        <FormTab label="Dream home">
          <DiscountPickerComponent
            discounts={stateDiscounts.raffle}
            handleChangeDiscountsStatus={handleChangeDiscountsStatus}
            isActiveDiscounts={isActiveDicounts.raffle}
            handleSetDiscounts={handleSetDiscount}
            handleSaveDiscounts={handleSaveDiscounts}
            competition="raffle"
            fillError={discountFillError.raffle}
          />
        </FormTab>
        <FormTab label="Lifestyle">
          <DiscountPickerComponent
            discounts={stateDiscounts.prize}
            handleChangeDiscountsStatus={handleChangeDiscountsStatus}
            isActiveDiscounts={isActiveDicounts.prize}
            handleSetDiscounts={handleSetDiscount}
            handleSaveDiscounts={handleSaveDiscounts}
            competition="prize"
            fillError={discountFillError.prize}
          />
        </FormTab>
        <FormTab label="Fixed Odds">
          <DiscountPickerComponent
            discounts={stateDiscounts.fixedOdds}
            handleChangeDiscountsStatus={handleChangeDiscountsStatus}
            isActiveDiscounts={isActiveDicounts.fixedOdds}
            handleSetDiscounts={handleSetDiscount}
            handleSaveDiscounts={handleSaveDiscounts}
            competition="fixedOdds"
            fillError={discountFillError.fixedOdds}
          />
        </FormTab>
      </TabbedForm>
    </Card>
  )
}